import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

// Lists
import ListPartijen from './views/lists/ListPartijen.vue';
import ListProjects from './views/lists/ListProjects.vue';

// Project
import ProjectBeknopt from './views/project/ProjectBeknopt.vue'

// Partijen
import PartijBeknopt from './views/stakeholder/PartijBeknopt.vue'


// Pages 
import PageAbout from './views/pages/About.vue';
import PageContact from './views/pages/Contact.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },

    // Project
    {
      path: '/projecten/:slug',
      name: 'project-beknopt',
      component: ProjectBeknopt
    },

    // Partijen 
    {
      path: '/betrokken-partijen/:slug',
      name: 'partij-beknopt',
      component: PartijBeknopt
    },
    
    // Lists
    {
      path: '/betrokken-partijen',
      name: 'list-partijen',
      component: ListPartijen
    },
    {
      path: '/projecten',
      name: 'list-projecten',
      component: ListProjects
    },

    // Pages
    {
      path: '/pages/about',
      name: 'page-about',
      component: PageAbout
    },
    {
      path: '/pages/contact',
      name: 'page-contact',
      component: PageContact
    }
  ]
})
